export const DOWNLOAD_REPORT_REQUEST = 'DOWNLOAD_REPORT_REQUEST'
export const DOWNLOAD_REPORT_SUCCESS = 'DOWNLOAD_REPORT_SUCCESS'
export const DOWNLOAD_REPORT_FALIURE = 'DOWNLOAD_REPORT_FALIURE'
